import { Image, Container, Row, Col } from 'react-bootstrap';
import Img from '../Img/Holiday/Holiday Banner.jpg';
import CircularGallery from './CircularHdayGallery';
import "./Services.css";

function Holiday() {
    return (
        <>
            <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col>
                        <h1 className='text-center my-4 text-decoration-underline'><strong>HOLIDAY</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>Our vendors employ traditional artisanal skills and various types of embroidery techniques to create charming tree skirts, stockings and various other ornaments for the latest Holiday collections.</p>
                    </Col>
                </Row>
            </Container>
            <div style={{ height: '600px', position: 'relative' }}>
                <CircularGallery bend={3} borderRadius={0.05} scrollEase={0.02} />
            </div>
        </>
    )
}

export default Holiday